module.exports = __webpack_public_path__ + "static/media/kofax_logo.26fa6ad8.svg";